// Copyright (c) 2021, 37.78 Tecnologia Ltda. All rights reserved.

import breakpoints from "./breakpoints";
import overrides from "./overrides";
import typography from "./typography";

const base = {
  breakpoints,
  overrides,
  typography,
};

export default base;
